module.exports = __webpack_public_path__ + "img/Search_16px_Icon-dark.5e602269.svg";